import request from '@/utils/request.js'

/***流量池管理列表***/
export function getFluxPoolMgtList(data){
    return request({
        url: 'simPool/manager/list',
        method: 'post',
        data
    })
}
export function getFluxPoolMgtLists(data){
    return request({
        url: 'simSupplier/sim/timer',
        method: 'post',
        data
    })
}
/***新增流量池***/
export function addFluxPool(data){
    return request({
        url: 'simPool/insert',
        method: 'post',
        data
    })
}
/***编辑流量池***/
export function editFluxPool(data){
    return request({
        url: 'simPool/update',
        method: 'post',
        data
    })
}
/***分配流量池列表***/
export function getAgentfluxPoolList(data){
    return request({
        url: 'simPool/agent/sold/list',
        method: 'post',
        data
    })
}
/***分配流量池***/
export function fluxPoolDistribute(data){
    return request({
        url: 'simPool/agent/sold/other',
        method: 'post',
        data
    })
}